import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-room-finished-page',
  templateUrl: './room-finished-page.component.html',
  styleUrls: ['./room-finished-page.component.css']
})
export class RoomFinishedPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
